export default __webpack_public_path__ + "static/media/logoWithoutShadow.ea27c817.svg";